import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getRootElement } from '../../../../common/scroll';
const BackToTop = () => {
    const [stateVisible, setVisible] = React.useState(false);
    React.useEffect(() => {
        const root = getRootElement();
        const onScroll = () => setVisible(root.scrollTop > 600);
        root.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => root.removeEventListener('scroll', onScroll);
    }, []);
    return !stateVisible ? null : (_jsx("button", { type: "button", className: "ptl-to-top btn btn-dark rounded-circle shadow", onClick: () => getRootElement().scrollTo({ top: 0, behavior: 'smooth' }), title: "Back to top", "aria-label": "Back to top", children: _jsx("i", { className: "bi bi-arrow-up" }) }));
};
export default BackToTop;
